import React, { useState } from 'react';
import { HashLink as NavLink } from 'react-router-hash-link';
import Typed from '../../../utils/TypedText';
import { headerData } from '../../../data/headerData';
import './landing.css';
import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter
} from 'react-icons/fa';
import { contactsData } from '../../../data/contactsData';

function LandingUI({ theme, classes }) {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div className='landing' style={{ backgroundColor: theme.quaternary }}>
      <div className='landing--container'>
        <div
          className='landing--container-left'
          style={{ backgroundColor: theme.quaternary }}
        >
          <div className='lcl--content'>
            {contactsData.linkedIn && (
              <a href={contactsData.linkedIn} target='_blank' rel='noreferrer'>
                <FaLinkedin
                  className='landing--social linkedin-icon'
                  style={{ color: theme.primary }}
                  aria-label='LinkedIn'
                />
              </a>
            )}
            {contactsData.github && (
              <a href={contactsData.github} target='_blank' rel='noreferrer'>
                <FaGithub
                  className='landing--social'
                  style={{ color: theme.primary }}
                  aria-label='GitHub'
                />
              </a>
            )}
            {contactsData.twitter && (
              <a href={contactsData.twitter} target='_blank' rel='noreferrer'>
                <FaTwitter
                  className='landing--social twitter-icon'
                  style={{ color: theme.primary }}
                  aria-label='Twitter'
                />
              </a>
            )}
            {contactsData.facebook && (
              <a href={contactsData.facebook} target='_blank' rel='noreferrer'>
                <FaFacebook
                  className='landing--social facebook-icon'
                  style={{ color: theme.primary }}
                  aria-label='Facebook'
                />
              </a>
            )}
            {contactsData.instagram && (
              <a href={contactsData.instagram} target='_blank' rel='noreferrer'>
                <FaInstagram
                  className='landing--social instagram-icon'
                  style={{ color: theme.primary }}
                  aria-label='Instagram'
                />
              </a>
            )}
          </div>
        </div>
        <img
          src={hovered ? headerData.imagebw : headerData.image}
          alt={headerData.name}
          className='landing--img'
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        <div
          className='landing--container-right'
          style={{ backgroundColor: theme.secondary }}
        >
          <div className='lcr--content' style={{ color: theme.tertiary }}>
            <h1>{headerData.name}</h1>
            <Typed
              strings={[
                'Embedded Systems Engineer',
                'IoT Product Builder',
                'Firmware + Hardware Integrator',
                'Full Stack & AI/ML Developer'
              ]}
              typeSpeed={45}
              backSpeed={35}
              className='typed-header'
              style={{ color: theme.primary, fontSize: '20px' }}
              loop
            />
            <p>{headerData.desciption}</p>

            <div className='lcr-buttonContainer'>
              <NavLink to='/#projects' smooth={true} spy='true' duration={2000}>
                <button className={classes.resumeBtn}>View Projects</button>
              </NavLink>
              <NavLink to='/#contacts' smooth={true} spy='true' duration={2000}>
                <button className={classes.contactBtn}>Let's Build</button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingUI;
